export default __webpack_public_path__ + "static/media/bg-login3.e5d63b62.webp";